export type SlideIntervalUnit = 'seconds' | 'minutes' | 'hours' | 'days';

export interface SlideshowAttachmentLike {
  id?: string;
  url: string;
  type?: string;
  name?: string;
  durationValue?: number;
  durationUnit?: SlideIntervalUnit;
  style?: string;
  resolution?: number;
}

export interface SlideshowLike {
  intervalValue?: number;
  intervalUnit?: SlideIntervalUnit;
  attachments?: SlideshowAttachmentLike[];
}

export const getIntervalMs = (value?: number, unit: SlideIntervalUnit = 'seconds') => {
  const intervalValue = Math.max(1, Number(value) || 10);
  switch (unit) {
    case 'minutes':
      return intervalValue * 60 * 1000;
    case 'hours':
      return intervalValue * 60 * 60 * 1000;
    case 'days':
      return intervalValue * 24 * 60 * 60 * 1000;
    case 'seconds':
    default:
      return intervalValue * 1000;
  }
};

export const getSlideIntervalMs = (slide?: SlideshowAttachmentLike, slideshow?: SlideshowLike) => {
  if (slide?.durationValue) {
    return getIntervalMs(slide.durationValue, slide.durationUnit || 'seconds');
  }
  return getIntervalMs(slideshow?.intervalValue, slideshow?.intervalUnit || 'seconds');
};

export const reorderSlideshowAttachments = <T extends SlideshowAttachmentLike>(attachments: T[], fromIndex: number, toIndex: number) => {
  const next = [...attachments];
  const [moved] = next.splice(fromIndex, 1);
  if (!moved) return next;
  next.splice(toIndex, 0, moved);
  return next;
};
